import { create } from 'zustand';

import { findBestViewForConcern, scoreKeyToConcern } from '../utils/detectionNavigation';
import { canonicalSkinConditionName, isSkinConditionName } from '../utils/skinResultsUtils';

const useSkinResultStore = create((set, get) => ({
  report: null,
  loading: false,
  error: null,
  requestStatus: 'idle',
  imageView: 'front',
  selectedConcern: null,
  selectedScoreKey: null,
  selectedLabel: null,
  showMaskOverlay: false,
  previewImage: null,
  previewDetections: null,
  previewSelectedConcern: null,
  previewView: 'front',

  setReport: (report) => set({ report, error: null }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setRequestStatus: (requestStatus) => set({ requestStatus }),

  setImageView: (imageView) => set({ imageView }),

  selectConcern: (concern, imageView, { preferMask = false } = {}) => {
    const report = get().report;
    const detections = report?.detections || {};
    const canonical = canonicalSkinConditionName(concern) || concern;
    const view = imageView || findBestViewForConcern(detections, canonical);
    set({
      selectedConcern: canonical,
      selectedScoreKey: null,
      selectedLabel: null,
      imageView: view,
      showMaskOverlay: preferMask && isSkinConditionName(canonical),
    });
  },

  selectScoreKey: (scoreKey) => {
    const concern = scoreKeyToConcern(scoreKey);
    if (!concern) return;
    get().selectConcern(concern, 'front', { preferMask: true });
    set({ selectedScoreKey: scoreKey });
  },

  selectLabel: (labelName) => {
    const report = get().report;
    const detections = report?.detections || {};
    const view = findBestViewForConcern(detections, labelName);
    set({
      selectedLabel: labelName,
      selectedConcern: labelName,
      selectedScoreKey: null,
      imageView: view,
      showMaskOverlay: false,
    });
  },

  clearSelection: () => set({
    selectedConcern: null,
    selectedScoreKey: null,
    selectedLabel: null,
    showMaskOverlay: false,
  }),

  toggleMaskOverlay: () => set((s) => ({ showMaskOverlay: !s.showMaskOverlay })),

  openPreview: (url, { detections = null, view = null, selectedConcern = null } = {}) => set({
    previewImage: url,
    previewDetections: detections,
    previewSelectedConcern: selectedConcern ?? get().selectedConcern,
    previewView: view || get().imageView,
  }),

  closePreview: () => set({
    previewImage: null,
    previewDetections: null,
    previewSelectedConcern: null,
    previewView: 'front',
  }),
}));

export default useSkinResultStore;
